
export const fuelTypesOption = [
    {
        value: "1",
        label: "Gas"
    },
  {
        value: "2",
        label: "Diesel"
    },
      {
        value: "3",
        label: "Petrol"
    },
      {
        value: "4",
        label: "Electric"
    },
]